import { render, staticRenderFns } from "./accessory.vue?vue&type=template&id=4f99bfd4"
import script from "./accessory.vue?vue&type=script&lang=js"
export * from "./accessory.vue?vue&type=script&lang=js"
import style0 from "./accessory.vue?vue&type=style&index=0&id=4f99bfd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default,Quantity: require('/app/components/quantity.vue').default,ProductPrices: require('/app/components/product/prices.vue').default,Loader: require('/app/components/loader.vue').default})
